module.exports = __webpack_public_path__ + "static/media/work1.1.163b44c0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/work1.1.webp
// module id = 520
// module chunks = 4